import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
// import convertToExcel from "../../../../components/ExportToExcel";
// import convertToExcel from "./ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";
import { toast } from "react-toastify";
import convertToExcel from "../../../../components/ExportToExcel";

const RanchWeighbridgeFarmerReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const formatNumber = (num) => {
    if (num === null || num === undefined) return "0.00";
    return Number(num).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [seasonData, setSeasondata] = useState([]);
  const [RanchData, setRanchdata] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [seasonId, setSeasonId] = useState(0);
  const [ranchId, setRanchId] = useState(0);
  const [seasonName, setSeasonName] = useState();
  const [RanchName, setRanchName] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [fieldName, setFieldName] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const [cropId, setCropId] = useState("");
  const [cropFilterList, setCropFilterList] = useState([]);


  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);
  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getRanchWeighBridgeFarmerData } = useHttp();

  const fillRanchWeighBridgeFarmerData = (
    employeeId,
    seasonId,
    farmerNo,
    ranchId,
    getType = ""
  ) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    if (ranchId && ranchId !== 0) {
      urlfilter += `&ranchId=${ranchId}`;
    }

    if (seasonId != 0) {
      urlfilter = urlfilter + `&seasonId=${seasonId}`;
    }
    if (cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (farmerNo != "") {
      urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    }

    if (getType != "") {
      urlfilter = urlfilter + `&getType=${getType}`;
    }

    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }

    var url = `/api/VehicleWeighbridgeFarmerReport/?page=${currentPage}&page_size=${itemsPerPage}&orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getRanchWeighBridgeFarmerData(
      {
        url: url,
      },
      (data) => {
        if (getType == "Excel") {
        } else {
          setData(data?.results?.data || []);
          setTotalCount(data?.count || 0);
        }
      }
    );
  };

  useEffect(() => {
    fillRanchWeighBridgeFarmerData(0, 0, "");
  }, [getRanchWeighBridgeFarmerData]);

  useEffect(() => {
    fillRanchWeighBridgeFarmerData(
      employeeId,
      seasonId,
      farmerNumber,
      ranchId
    );
  }, [
    employeeId,
    seasonId,
    cropId,
    farmerNumber,
    ranchId,
    fieldName,
    selectedFromDate,
    selectedToDate,
    showDateFilter,
    currentPage
  ]);

  useEffect(() => {
  if (!ranchId) {
    setFieldOptions([]);
    return;
  }

  var urlfilter = `&ranchId=${ranchId}`;

  getRanchWeighBridgeFarmerData(
    {
      url: `/api/VehicleWeighbridgeFarmerReport/?orgId=${localStorage.getItem(
        "orgId"
      )}&empId=${localStorage.getItem("empId")}${urlfilter}`,
    },
    (res) => {

      const reportData =
        res?.results?.data ||
        res?.data ||
        [];

      const uniqueFields = [
        ...new Set(
          reportData
            .map((item) => item.fieldCode)
            .filter(Boolean)
        ),
      ];

      const fieldList = uniqueFields.map((f) => ({
        fieldCode: f,
      }));

      setFieldOptions(fieldList);
    }
  );
}, [ranchId]);



  const fieldsToExport = [
    "docNo",
    "harvestDate",
    "harvestId",
    "specificFieldPick",
    "truckId",
    "farmerNo",
    "farmerName",
    "seasonName",
    "cropName",
    "ranchName",
    "fieldCode",
    "plotName",
    "executiveName",
    "harvestOfficer",
    "areaOfPlot",
    "areaUnit",
    "cratesBagQtyLoaded",
    "averageWeightOfCratesInKg",
    "extraQty",
    "totalWeight",
    "farmerShareCratesBagQtyLoaded",
    "farmerShareAverageWeightOfCratesInKg",
    "farmerShareExtraQty",
    "farmerShareTotalQuantity",
    "grandTotal",
    "fruitQuality",
    "invoiceStatus",
  ];

  const customHeaders = [
    "Doc No",
    "Date of Harvest",
    "Harvest ID",
    "Specific Field Pick",
    "Truck ID",
    "Farmer No",
    "Farmer Name",
    "Season Name",
    "Crop Name",
    "Ranch Name",
    "Field Name",
    "Plot No",
    "Executive Name",
    "Harvest Officer",
    "Area of Plot",
    "Area Unit",

    // Tomatojo’s Share
    "Tomatojo’s Share - No. of Containers",
    "Tomatojo’s Share - Average Weight of Crate/Bag",
    "Tomatojo’s Share - Extra Qty Crates/Bag (Kg)",
    "Tomatojo’s Share - Total Weight Crates/Bag (Kg)",

    // Farmer’s Share
    "Farmer’s Share - No. of Containers",
    "Farmer’s Share - Average Weight of Crate/Bag",
    "Farmer’s Share - Extra Qty Crates/Bag (Kg)",
    "Farmer’s Share - Total Weight Crates/Bag (Kg)",
    "Grand Total",

    "Fruit Quality",
    "Invoice Status",
  ];

  const handleExportExcel = async () => {

    let urlfilter = "";

    if (showDateFilter) {
      urlfilter += `&fromDate=${selectedFromDate}`;
      urlfilter += `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter += `&fieldExecutiveId=${employeeId}`;
    }

    if (ranchId && ranchId !== 0) {
      urlfilter += `&ranchId=${ranchId}`;
    }

    if (seasonId != 0) {
      urlfilter += `&seasonId=${seasonId}`;
    }

    if (cropId !== "") {
      urlfilter += `&cropId=${cropId}`;
    }

    if (farmerNumber != "") {
      urlfilter += `&farmerNo=${farmerNumber}`;
    }

    if (fieldName && fieldName !== "") {
      urlfilter += `&fieldId=${fieldName}`;
    }

    const exportUrl =
      `/api/VehicleWeighbridgeFarmerReport/?isExport=true&orgId=${localStorage.getItem(
        "orgId"
      )}&empId=${localStorage.getItem("empId")}${urlfilter}`;

    getRanchWeighBridgeFarmerData(
      {
        url: exportUrl,
      },
      (res) => {

        const exportData = res?.data || [];

        if (!exportData.length) {
          toast.error("No data available to export!");
          return;
        }

        const filename = "FarmerHarvestDetails.xlsx";

        const formattedData = exportData.map((item) => ({
          ...item,
          invoiceStatus:
            item.invoiceStatus === 1 || item.invoiceStatus === true
              ? "Yes"
              : "No",
        }));

        convertToExcel(
          formattedData,
          fieldsToExport,
          filename,
          customHeaders
        );
      }
    );
  };

  // const { sendRequest: getEmp } = useHttp();

  // const EmployeeDetail = () => {
  //   getEmp(
  //     {
  //       url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
  //         "empId"
  //       )}&orgId=${localStorage.getItem("orgId")} `,
  //     },
  //     (data) => {
  //       var emplist = data;

  //       setEmployeeData(emplist);
  //     }
  //   );
  // };

  // useEffect(() => {
  //   EmployeeDetail();
  // }, [getEmp]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);


  const { sendRequest: getSeasonData } = useHttp();
  useEffect(() => {
    getSeasonData(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setSeasondata(data);
      }
    );
  }, [getSeasonData]);

  const { sendRequest: getCropList } = useHttp();

  useEffect(() => {
    getCropList(
      {
        url: `/api/farmerCropList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        console.log("Crop API Full Response:", res);
        setCropFilterList(res?.output);
      }
    );
  }, [getCropList]);

  const { sendRequest: getRanchData } = useHttp();
  useEffect(() => {
    getRanchData(
      {
        url: `/api/ranchDetail/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("season", data);

        setRanchdata(data);
      }
    );
  }, [getRanchData]);

  const { sendRequest: getFarmerNumber } = useHttp();
  useEffect(() => {
    var url = "";
    if (employeeId > 0) {
      url = url + '&fieldExecutiveId=' + employeeId;
    }

    if (seasonId > 0) {
      url = url + '&seasonId=' + seasonId;
    }

    if (ranchId > 0) {
      url = url + '&ranchId=' + ranchId;
    }


    getFarmerNumber(
      {
        url: `/api/harvestFarmerNumberList/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem(
          "empId"
        )}${url}`,
      },
      (data) => {
        setFarmerData(data);
      }
    );
  }, [getFarmerNumber, employeeId, ranchId, seasonId]);


  const handleSearch = (value) => {
    setFarmerNumber(value);
    setData([]);
  };

  // const options = farmerData&&farmerData.map(item => ({ value: item.identificationNo }));

  const filteredOptions =
    farmerData &&
    farmerData
      .filter((item) => item.farmerNo.includes(farmerNumber))
      .map((item) => ({ value: item.farmerNo }));

  //console.log(filteredOptions);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-md-8 mt-3">
            <label className="card-title mx-3">
              Farmer Harvest Details
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Crop Name</label>

                  <select
                    id="cropNameId"
                    className="form-control"
                    value={cropId}
                    onChange={(e) => {
                      setCropId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>

                    {cropFilterList &&
                      cropFilterList.map((x) => (
                        <option key={x.CropId} value={x.CropId}>
                          {x.CropName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              {/* Season Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Season Name</label>
                  <select
                    id="seasonId"
                    className="form-control"
                    ref={(el) => (frmRef.current["seasonId"] = el)}
                    value={seasonId}
                    onChange={(e) => {
                      var sId = "";
                      if (e.target.value != "--Select--") {
                        sId = e.target.value;
                      }
                      // setSeasonName(sName);
                      setSeasonId(sId);
                      EmployeeDetail(sId);
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {seasonData &&
                      seasonData.map((x) => (
                        <option key={x.seasonId} value={x.seasonId}>
                          {x.seasonName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {/* Ranch Name */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Ranch Name</label>
                  <select
                    id="ranchId"
                    className="form-control"
                    ref={(el) => (frmRef.current["ranchId"] = el)}
                    value={ranchId}
                    onChange={(e) => {
                      var rId = "";
                      if (e.target.value != "--Select--") {
                        rId = e.target.value;
                      }

                      setRanchId(rId);
                      setFieldName(""); // add this
                      setEmployeeId(0);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {RanchData &&
                      RanchData.map((x) => (
                        <option key={x.ranchId} value={x.ranchId}>
                          {x.ranchName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-md-3">
                <div className="form-group">
                  <label>Field Name</label>
                  <select
                    className="form-control"
                    value={fieldName}
                    onChange={(e) => {
                      setFieldName(e.target.value);
                    }}
                  >
                    <option value="">Select</option>

                    {fieldOptions.map((x, i) => (
                      <option key={i} value={x.fieldCode}>
                        {x.fieldCode}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Procurement Officer */}
              {/* <div className="col-md-3">
                <div className="form-group">
                  <label>Field Officer</label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;
                      setData([]);
                      setEmployeeId(userid);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.userId} value={x.userId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div> */}



              {/* Farmer Number */}
              <div className="col-md-3">
                <label htmlFor="farmer_number">Farmer Number</label>
                <AutoComplete
                  className="form-control"
                  style={{ height: "30px" }}
                  value={farmerNumber}
                  options={filteredOptions}
                  placeholder="Farmer Number"
                  onChange={handleSearch}
                />
              </div>

              {/* Date Filter */}
              <div className="col-md-3">
                <div className="form-group">
                  <label>Apply Date Filter</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>

              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Submit */}
              <div className="col-md-3 text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillRanchWeighBridgeFarmerData(
                        employeeId,
                        seasonId,
                        farmerNumber,
                        ranchId
                      );
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        {/* Report Table */}
        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning mx-3"
                onClick={handleExportExcel}
                disabled={loading}
              >
                {loading ? (
                  <i className="fas fa-spinner fa-spin"></i>
                ) : (
                  <i className="fas fa-file-excel"></i>
                )}
              </button>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div
                    className="card-body"
                    style={{ padding: "0.4rem", overflowX: "auto" }}
                  >
                    <table
                      className="table table-bordered table-responsive text-center table-sm"
                      style={{ minWidth: "1800px", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr className="table-header">
                          <th rowSpan="2">Doc No</th>
                          <th rowSpan="2">Date of Harvest</th>
                          <th rowSpan="2">Harvest ID</th>
                          <th rowSpan="2">Specific Field Pick</th>
                          <th rowSpan="2">Truck ID</th>
                          <th rowSpan="2">Farmer No</th>
                          <th rowSpan="2">Farmer Name</th>
                          <th rowSpan="2">Season Name</th>
                          <th rowSpan="2">Crop Name</th>
                          <th rowSpan="2">Ranch Name</th>
                          <th rowSpan="2">Field Name</th>
                          <th rowSpan="2">Plot No</th>
                          <th rowSpan="2">Executive Name</th>
                          <th rowSpan="2">Harvest Officer</th>
                          <th rowSpan="2">Area of Plot</th>
                          <th rowSpan="2">Area Unit</th>

                          {/* Group Headers */}
                          <th
                            colSpan="4"
                            style={{ backgroundColor: "#f9f9f7ff" }}
                          >
                            Tomatojo’s Share
                          </th>
                          <th
                            colSpan="4"
                            style={{ backgroundColor: "#f2f2f1ff" }}
                          >
                            Farmer’s Share
                          </th>
                          <th rowSpan="2">Grand Total</th>
                          <th rowSpan="2">Fruit Quality</th>
                          <th rowSpan="2">Invoice Status</th>
                        </tr>

                        {/* Sub-Headers */}
                        <tr className="table-header">
                          {/* Tomatojo’s Share */}
                          <th>No. of Crates/Bag (Kg) </th>
                          <th>Average Weight of Crate/Bag</th>
                          <th>Extra Qty Crates/Bag (Kg)</th>
                          <th>Total Weight Crates/Bag (Kg)</th>

                          {/* Farmer’s Share */}
                          <th>No. of Crates/Bag (Kg)</th>
                          <th>Average Weight of Crate/Bag</th>
                          <th>Extra Qty Crates/Bag (Kg)</th>
                          <th>Total Weight Crates/Bag (Kg)</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data &&
                          data.map((itm, i) => (
                            <tr key={i} className="tablerowview">
                              <td>{itm.docNo}</td>
                              <td>{itm.harvestDate}</td>
                              <td>{itm.harvestId}</td>
                              <td>{itm.specificFieldPick}</td>
                              <td>{itm.truckId}</td>
                              <td>{itm.farmerNo}</td>
                              <td>{itm.farmerName}</td>
                              <td>{itm.seasonName}</td>
                              <td>{itm.cropName}</td>
                              <td>{itm.ranchName}</td>
                              <td>{itm.fieldCode}</td>
                              <td>{itm.plotName}</td>
                              <td>{itm.executiveName}</td>
                              <td>{itm.harvestOfficer}</td>
                              <td>{formatNumber(itm.areaOfPlot)}</td>
                              <td>{itm.areaUnit}</td>

                              {/* Tomatojo’s Share */}
                              <td>{formatNumber(itm.cratesBagQtyLoaded)}</td>
                              <td>
                                {formatNumber(itm.averageWeightOfCratesInKg)}
                              </td>
                              <td>{formatNumber(itm.extraQty)}</td>
                              <td>{formatNumber(itm.totalWeight)}</td>

                              {/* Farmer’s Share */}
                              {itm.cropName?.toLowerCase() === "tomato" ? (
                                <>
                                  <td>0.00</td>
                                  <td>0.00</td>
                                  <td>0.00</td>
                                  <td>0.00</td>
                                </>
                              ) : (
                                <>
                                  <td>
                                    {formatNumber(
                                      itm.farmerShareCratesBagQtyLoaded
                                    )}
                                  </td>
                                  <td>
                                    {formatNumber(
                                      itm.farmerShareAverageWeightOfCratesInKg
                                    )}
                                  </td>
                                  <td>
                                    {formatNumber(itm.farmerShareExtraQty)}
                                  </td>
                                  <td>
                                    {formatNumber(itm.farmerShareTotalQuantity)}
                                  </td>
                                </>
                              )}

                              <td>{itm.grandTotal}</td>
                              <td>{itm.fruitQuality}</td>
                              <td>{itm.invoiceStatus ? "Yes" : "No"}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={totalCount}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RanchWeighbridgeFarmerReport;
